module.exports = __webpack_public_path__ + "img/SR.ba3c45c0.svg";